module.exports = __webpack_public_path__ + "img/notifications.2e701fb1.svg";